import { Injectable } from "@angular/core";
import { StoreService } from "angular-simple-redux-lib";
import { UsersState } from "../model/users.service.models";

@Injectable({
  providedIn: "root",
})
export class UsersStateService extends StoreService<UsersState> {}
